import React, { FC, useCallback, useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react'
import { Price, ProductImage, Stepper, Tags } from 'components'
import { classNames } from '@dt/fe-utils'
import CashierController from 'controllers/cashierController'
import { cartMobx } from 'restaurant'
import Config from 'common/config/config'
// import MonthSaleInfo from '../MonthSaleInfo'
import productStyleController from '@ctrls/productStyleController'
// import { prodRecommendContent } from '../../../index'
import './index.scss'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list';
interface IProps {
  type?: TProductItem;
  className?: string;
  style?: any;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
  onClick?: () => void;
  id?: string;
}
// 瀑布流图片的宽度
const WaterfallItem: FC<IProps> = (props) => {
  const { style, id = '', onClick, className = '' } = props

  return (
    <div
      className={classNames(
        'product-item waterfall',
        className,
        // type,
        // {
        //   // 'product-shake': recommendShakeProduct && recommendShakeProduct?.no === product.no,
        //   'sold-out': soldout,
        // }
      )}
      style={style ? {
        visibility: style.left >= 0 ? 'visible' : 'hidden',
        left: style.left,
        top: style.top
      } : null}
      id={id}
      onClick={() => onClick()}
    >
      {props.children}
    </div>
  )
}
export default observer(WaterfallItem)
